export enum Language {
  DE = 'de',
  EN = 'en',
}
